import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useLocation } from "react-router-dom";

const OtpModal = ({ open, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const route = location.pathname;

  const handleVerify = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/otp/verify-otp`, {
        otp,
        route,
      });
      if (res.data.verified) {
        onVerified(res.data.token); // Pass token back to ProtectedRoutePage
      } else {
        setMessage("Invalid or expired OTP");
      }
    } catch (err) {
      setMessage("Invalid or expired OTP");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open}>
      <DialogTitle>Enter OTP</DialogTitle>
      <DialogContent>
        <TextField
          label="OTP"
          fullWidth
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          sx={{ my: 2 }}
        />
        <Button onClick={handleVerify} disabled={loading} variant="contained" fullWidth>
          {loading ? "Verifying..." : "Verify OTP"}
        </Button>
        {message && (
          <Typography variant="body2" color="error" sx={{ mt: 1 }}>
            {message}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OtpModal;
